import locales from './locales/en-es.json';

export default {
  ...locales,
  app_title: 'Iniciadora',

  locales_en_US: 'Inglés (US)',
  locales_en_CA: 'Inglés (CA)',
  locales_fr_CA: 'Francés (CA)',
  locales_es_US: 'Español (US)',

  actions_back: 'Regresar',
  actions_continue: 'Continuar',

  about_pageTitle: 'Acerca de',
  home_pageTitle: 'Página inicial',
  onexExamples_pageTitle: 'Ejemplos de OneX',
};
